export const MODALS_REQUEST_PARAMS_BY_ENTITY = {
  states: {
    dimensions: ["org_view_states.code"]
  },
  districts: {
    dimensions: [
      "org_view_districts.districtId",
      "org_view_districts.districtName"
    ]
  },
  organizations: {
    dimensions: ["org_view_organizations.id", "org_view_organizations.name"]
  },
  schools: {
    dimensions: [
      "org_view_schools.id",
      "org_view_schools.name",
      "org_view_schools.districtId"
    ]
  },
  grades: {
    dimensions: ["grades.grade"]
  },
  teachers: {
    dimensions: [
      "org_view_teachers.id",
      "org_view_teachers.fullName",
      "org_view_teachers.districtId",
      "org_view_teachers.schoolId"
    ]
  }
}
